/**
 * <s-sticky-buy> — mobile sticky buy bar for the product page.
 *
 * Shows itself (data-visible, removes inert) once the element matched by
 * data-watch has scrolled above the viewport, and hides again when it returns.
 * [data-sticky-action="add"] presses the real Add to cart button so the normal
 * product form flow runs; [data-sticky-action="scroll"] brings the form back
 * into view so the buyer can pick a colour.
 */
class SStickyBuy extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    const watched = this.dataset.watch ? document.querySelector(this.dataset.watch) : null;
    if (watched) {
      this.#observer = new IntersectionObserver(([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.toggleAttribute('data-visible', scrolledPast);
        this.inert = !scrolledPast;
      });
      this.#observer.observe(watched);
    }
    this.addEventListener('click', (event) => this.#onClick(event), { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #onClick(event) {
    const action = event.target instanceof Element ? event.target.closest('[data-sticky-action]') : null;
    if (!action) return;
    const watched = this.dataset.watch ? document.querySelector(this.dataset.watch) : null;
    if (action.dataset.stickyAction === 'add') {
      const addButton = watched?.querySelector('button[name="add"]:not([disabled])');
      if (addButton) {
        addButton.click();
        return;
      }
    }
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    watched?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  }
}

if (!customElements.get('s-sticky-buy')) customElements.define('s-sticky-buy', SStickyBuy);
